import SmartButton from "../../buttons/SmartButton";

function TablaRegisteredCPAsRow({ cpa, onSendReminder }) {
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "Never";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (error) {
      return "Never";
    }
  };

  return (
    <tr>
      <td>{formatDate(cpa.date_joined)}</td>
      <td>{cpa.first_name}</td>
      <td>{cpa.last_name}</td>
      <td>{cpa.email}</td>
      <td>
        <span className="status-badge">{cpa.account_status_display}</span>
      </td>
      <td>{formatDate(cpa.last_reminder_sent)}</td>
      <td>
        <SmartButton
          text="Send Reminder"
          icon="mail"
          onClick={() => onSendReminder(cpa)}
          className="btnAccept"
        />
      </td>
    </tr>
  );
}

export default TablaRegisteredCPAsRow;
